import { cpmConstants } from "../actions/actionTypes";
import { getConsents } from "services/cpm.service";
import { consentOptions } from "constants/PreferencesConst";
import { CPM_CONSENT_NO } from "constants/cpm";

export const loadConsents = (email) => async (dispatch) => {
  try {
    const response = await getConsents(email);
    const data = await response.json();
    dispatch(success(data));
  } catch (_error) {
    // Fall back to default "No" consents on any failure — the CPM API
    // (id-cpm-gateway) is still on Phantom and may not be reachable from
    // the Bosun environment. Showing checkboxes with "No" defaults is always
    // preferable to hiding the section entirely.
    let consents = { consents: [] };
    consentOptions.forEach((element) => {
      consents.consents.push({
        consent: CPM_CONSENT_NO,
        mission: element.key,
      });
    });
    dispatch(success(consents));
  }
};

function success(consents) {
  return {
    type: cpmConstants.CPM_SUCCESS,
    consents: consents,
  };
}
